/**
 * Custom tin minimum quantities (1 kg equivalent per size).
 * Keep in sync with snippets/cyk-custom-tin-min-qty.liquid.
 *
 * Shopify Admin setup (required for checkout enforcement):
 * Products > Custom Tin > each variant > Minimum order quantity:
 *   30g = 33, 50g = 20, 125g = 8, 250g = 4, 500g = 2, 1kg = 1
 */
window.CYK_MIN_QTY_MAP = {
  '30g': 33,
  '50g': 20,
  '125g': 8,
  '250g': 4,
  '500g': 2,
  '1kg': 1,
};

window.cykOptionNameIndex = function (product, matcher) {
  const names = (product && product.options) || [];
  for (let i = 0; i < names.length; i++) {
    if (matcher(String(names[i] || ''))) return i;
  }
  return -1;
};

window.cykVariantOptionByIndex = function (variant, index) {
  if (!variant || index < 0 || index > 2) return null;
  return variant[['option1', 'option2', 'option3'][index]];
};

window.cykGetTinColorOptionIndex = function (product) {
  return window.cykOptionNameIndex(product, function (n) {
    return n.trim().toLowerCase() === 'tin color';
  });
};

window.cykGetSizeOptionIndex = function (product) {
  const tinIdx = window.cykGetTinColorOptionIndex(product);
  const names = (product && product.options) || [];
  if (!names.length) return 0;
  for (let i = 0; i < names.length; i++) {
    if (i !== tinIdx) return i;
  }
  return 0;
};

window.cykGetVariantSize = function (variant, product) {
  const idx = window.cykGetSizeOptionIndex(product);
  const raw = window.cykVariantOptionByIndex(variant, idx);
  return raw != null ? String(raw).trim() : '';
};

window.cykGetVariantTinColor = function (variant, product) {
  const tinIdx = window.cykGetTinColorOptionIndex(product);
  const idx = tinIdx >= 0 ? tinIdx : 1;
  const raw = window.cykVariantOptionByIndex(variant, idx);
  return raw != null ? String(raw).trim() : '';
};

window.cykGetMinQty = function (variant, product) {
  if (!variant) return 1;

  const size = window.cykGetVariantSize(variant, product).toLowerCase();
  if (!size) return 1;

  return window.CYK_MIN_QTY_MAP[size] || 1;
};

window.cykGetCartItemMinQty = function (input) {
  const min = parseInt(input.dataset.min, 10);
  if (!Number.isNaN(min) && min > 0) return min;

  const variantId = input.dataset.quantityVariantId;
  if (!variantId || !window.CYK_CART_VARIANTS) return 1;

  const entry = window.CYK_CART_VARIANTS[variantId];
  if (!entry || !entry.isCustomizer) return 1;

  return window.CYK_MIN_QTY_MAP[String(entry.size || '').toLowerCase()] || 1;
};
